import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntermarketingPage } from './intermarketing';

@NgModule({
  declarations: [
    IntermarketingPage,
  ],
  imports: [
    IonicPageModule.forChild(IntermarketingPage),
  ],
})
export class IntermarketingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/intermarketing/intermarketing.module.ts